import React, { useState } from "react";

import { Box } from "@mui/material";

import { Machines as MachinesContent } from "./Machines";
import { Mappings } from "../iotmappings/Mappings";

import { SlidingContainer } from "../../common/components/SlidingContainers";

const MachinesWrapper = () => {
  const [position, setPosition] = useState("first")

  const FirstElement = () => (
    <MachinesContent handleSlide={setPosition} />
  );

  const SecondElement = () => (
    <Mappings handleSlide={setPosition} />
  );

  return (
    <Box sx={{ width: "100%", bgcolor: "background.paper", padding: "2%" }}>
      <SlidingContainer position={position} firstElement={FirstElement} secondElement={SecondElement} changePosition={(val) => setPosition(val)} />
    </Box>
  );
};

export { MachinesWrapper as Machines };